/**
 * Label normalization — mirrors backend `normalizeLabelKey` (trim + lowercase).
 * Use for dedupe / exact-match comparisons only; display casing is preserved.
 */
export const normalizeLabelKey = (label: string): string => label.trim().toLowerCase();
